<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
    <nprogress-container></nprogress-container>
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      :logo="logo"
      :title="title"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          v-if="showMenu('crm.route.dashboard')"
          :link="{
            name: 'Dashboard',
            icon: 'dashboard',
            path: { name: 'Dashboard' }
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showMenu('crm.route.customer')"
          :link="{
            name: 'Customers',
            icon: 'group',
            path: { name: 'Customer Management' }
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showMenu('crm.route.enquiries')"
          :link="{
            name: 'Enquiries',
            icon: 'textsms',
            path: { name: 'Enquiry Management' }
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showMenu('crm.route.booking')"
          :link="{
            name: 'Bookings',
            icon: 'event_available',
            path: { name: 'Booking Management' }
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showMenu('crm.route.tour')"
          :link="{
            name: 'Adventures',
            icon: 'public',
            path: { name: 'Adventure Management' }
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="showMenu('crm.route.reports')"
          :link="{
            name: 'Reports',
            icon: 'content_paste',
            path: { name: 'Reporting' }
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import store from "@/store";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import NprogressContainer from "vue-nprogress/src/NprogressContainer";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    NprogressContainer
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "purple",
      sidebarBackgroundImage: "/img/hi_sidebar_bg_2.png",
      sidebarMini: true,
      sidebarImg: true,
      logo: "/img/hi-logo-v2.png",
      title: process.env.VUE_APP_TITLE
    };
  },
  methods: {
    showMenu(route) {
      return this.$allowed([route], ["super-admin", "admin"]);
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
